module.exports = __webpack_public_path__ + "img/sh-ac.de895001.svg";